import { Colors } from "../preset.constants";

export const floatlabelPreset = {
    on: {
        active: {
            background: Colors.PrimaryBackground
        }
    }
}